import {Button, Card, CardBody, CardHeader, Typography,} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import {UserRoleReportGrid} from "./grid";
import {submitUserRoleReport} from "../../../services/report/user";
import SelectInput from "../../system/select";
import {getPersonsNameAndFamilyByRole, getPersonsPhone} from "../../../services/profile/profile";
import Dict from "../../../helper/dict";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import {CardFooterPaginator} from "../../system/cardFooterPaginator";
import {PaginateContext} from "../../../context/paginate";
import {getRoles} from "../../../services/user/role";

export function UserRoleReportManagement() {

  const [userRoleReport, setUserRoleReport] = useState([]);
  const [lastDataRefresh, setLastDataRefresh] = useState(null);
  const [gridRowCount, setGridRowCount] = useState(10);
  const [gridCurrentPage, setGridCurrentPage] = useState(1);
  const [gridTotalRowCount, setGridTotalRowCount] = useState(0);
  const [sortBy, setSortBy] = useState("id")
  const [sortType, setSortType] = useState(false);
  const [from, setFrom] = useState((gridCurrentPage - 1) * gridRowCount + 1);
  const [to, setTo] = useState((gridCurrentPage) * gridRowCount);

  const [roleId, setRoleId] = useState(1);
  const [personId, setPersonId] = useState(null);
  const [phone, setPhone] = useState(null);

  useEffect(() => {
    if ((gridCurrentPage) * gridRowCount <= gridTotalRowCount) {
      setTo((gridCurrentPage) * gridRowCount)
    } else {
      setTo(gridTotalRowCount)
    }
    if (gridTotalRowCount === 0) {
      setFrom(0)
    } else {
      setFrom((gridCurrentPage - 1) * gridRowCount + 1)
    }
  }, [gridCurrentPage, gridRowCount, gridTotalRowCount]);

  async function getData(data, paginate) {
    const result = await submitUserRoleReport(data, paginate);
    if (result.status === 200) {
      const {user_role_report, total_count} = result.data;
      setUserRoleReport(user_role_report || []);
      setGridTotalRowCount(total_count);
    }
  }

  const filter = () => {
    const data = {}
    if (roleId) {
      data.role_id = parseInt(roleId);
    }

    if (personId) {
      data.person_id = personId;
    }

    return data
  };

  useEffect(() => {
    const data = filter()
    const paginate = new URLSearchParams({
      "sort_by": sortBy,
      "sort_type": sortType === false ? "DESC" : "ASC",
      "limit": parseInt(gridRowCount),
      "offset": (parseInt(gridCurrentPage) - 1) * parseInt(gridRowCount),
    }).toString()

    getData(data, paginate)
  }, [personId, roleId, gridCurrentPage, gridRowCount, sortBy, sortType]);

  return (
    <PaginateContext.Provider value={{
      setSortBy: setSortBy,
      sortType: sortType,
      setSortType: setSortType,
      active: gridCurrentPage,
      setActive: setGridCurrentPage,
      totalRows: gridTotalRowCount,
      rowsCount: gridRowCount,
      setRowsCount: setGridRowCount,
      from: from,
      to: to,
    }}>
      <div className="w-full">
        <Card className="pt-8 w-full">
          <CardHeader floated={true} shadow={false} className="rounded-none w-full">
            <div className="mb-8 flex items-center justify-between gap-8">
              <Typography variant="h5" color="blue-gray">کاربران به تفکیک نقش</Typography>
            </div>

          </CardHeader>
          <CardBody className="overflow-x-auto w-full">
            <div className="grid grid-cols-1 gap-1 mb-2 md:grid-cols-3 xxl:grid-cols-3">

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("role")}
                  defaultValue={roleId}
                  multiselect={false}
                  autoLoadService={getRoles}
                  autoLoadRender={({title}) => Dict(title)}
                  onChange={setRoleId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={"نام"}
                  defaultValue={personId}
                  refreshSignal={roleId}
                  autoLoadService={getPersonsNameAndFamilyByRole}
                  autoLoadServiceData={roleId}
                  autoLoadRender={({name, family, phone}) => {
                    const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                    return fullName + " - " + phone
                  }}
                  onChange={setPersonId}
                />
              </div>

              <div className="flex flex-col">
                <SelectInput
                  label={Dict("phone")}
                  defaultValue={personId}
                  refreshSignal={personId}
                  // multiselect={false}
                  autoLoadService={getPersonsPhone}
                  autoLoadRender={({phone}) => {
                    return persianNumberFormat(phone)
                  }}
                  onChange={setPersonId}
                />
              </div>

            </div>

            <div className="flex flex-row">
              <Button variant="gradient" color="gray" onClick={() => {
                setPersonId(null)
                setRoleId(null)
              }} className="ml-1">
                <span>حذف فیلتر</span>
              </Button>
            </div>

            <UserRoleReportGrid
              userReport={userRoleReport}
            />

          </CardBody>
          <CardFooterPaginator/>
        </Card>
      </div>
    </PaginateContext.Provider>
  )
    ;
}
